import React from 'react';
import { InstagramEmbed } from 'react-social-media-embed';
import "./social.css";
import personaje_1 from 'assets/images/red-personaje-1.png';
import personaje_5 from 'assets/images/red-personaje-5.png';
import elem2 from 'assets/images/red-elem2.png';
import elem4 from 'assets/images/red-elem4.png';
import elem5 from 'assets/images/red-elem5.png';
import elem6 from 'assets/images/red-elem6.png';
import elem8 from 'assets/images/red-elem8.png';
import elem9 from 'assets/images/red-elem9.png';
import elem10 from 'assets/images/red-elem10.png';
// {/* GET https://graph.facebook.com/v19.0/{INSTAGRAM_USER_ID}/media?fields=permalink&access_token={ACCESS_TOKEN}

export default function Social() {
  return (
    <div className="ricoendata-social">
      <div className="wrapper">
        <h3>Mirá nuestros posteos en <span>Instagram</span></h3>
        <div className="txts">
          <p>Conocé las novedades del proyecto RICO.EN.DATA.</p>
          <a href='https://www.youtube.com/watch?v=rzg-3LcxMtg' target='_blank' rel='noreferrer' className='vistevideos'>VISTE los videos?</a>
        </div>
        <div className='instagram-container'>
          <InstagramEmbed url="https://www.instagram.com/p/DDM8hIiu8_G/" width={328} />
        </div>
        <div className="elems">
          <img className="elem elem2" src={elem2} alt="" />
          <img className="elem elem2b" src={elem2} alt="" />
          <img className="elem elem4" src={elem4} alt="" />
          <img className="elem elem5" src={elem5} alt="" />
          <img className="elem elem5b" src={elem5} alt="" />
          <img className="elem elem6" src={elem6} alt="" />
          <img className="elem elem8" src={elem8} alt="" />
          <img className="elem elem9" src={elem9} alt="" />
          <img className="elem elem9b" src={elem9} alt="" />
          <img className="elem elem10" src={elem10} alt="" />
          <img className="elem elem10b" src={elem10} alt="" />
          <img className="elem personaje_1" src={personaje_1} alt="" />
          <img className="elem personaje_5" src={personaje_5} alt="" />
        </div>
      </div>
    </div>
  );
}